import { render, staticRenderFns } from "./Rocker.vue?vue&type=template&id=2cc520dc"
import script from "./Rocker.vue?vue&type=script&lang=js"
export * from "./Rocker.vue?vue&type=script&lang=js"
import style0 from "./Rocker.vue?vue&type=style&index=0&id=2cc520dc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports